import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Header } from '../types/Header';
import { HttpClient } from '@angular/common/http';

const API_ENDPOINT = 'http://localhost:8080/api/v1/';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  constructor(private http: HttpClient) { }



}
